import { useState } from 'react'
import { handleError } from '../model/handleError';
import { alertService } from '../services/AlertService';
const {REACT_APP_REST_ENDPOINT} = process.env;

const useFileUpload = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [statusUpload, setStatusUpload] = useState("");
    const [progressUpload, setProgressUpload] = useState(0);
    const [isLoadingUploadFile, setIsLoadingUploadFile] = useState(false);
  
    const handleFileChange = (event) => {
      const file = event.target.files[0];
      setSelectedFile(file);
    };
  
    const handleFileUpload = async (selectedContenuto, printAllAree, setSelectedContenuto) => {
      if (!selectedFile) {
        return;
      }
  
      const chunkSize = 5 * 1024 * 1024; 
      const totalChunks = Math.ceil(selectedFile.size / chunkSize);
      const chunkProgress = 100 / totalChunks;
      let chunkNumber = 1;
      let start = 0;
      let end = chunkSize;
  
      const uploadNextChunk = async () => {
        if (chunkNumber <= totalChunks) {
          const chunk = selectedFile.slice(start, end);
          const formData = new FormData();
          formData.append("file", chunk);
          formData.append("chunk", chunkNumber);
          formData.append("chunks", totalChunks);
          formData.append("id_corso", selectedContenuto?.id_corso);
          formData.append("id_contenuto", selectedContenuto?.id_contenuto);
          formData.append("originalname", selectedFile.name);
          formData.append("file_name", selectedFile.name);
          const token = localStorage.getItem('token');
          setIsLoadingUploadFile(true)
          fetch(`${REACT_APP_REST_ENDPOINT}/contenuti/upload`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
              },
            body: formData,
          })
            .then((response) => {
              if (!response.ok) throw new Error(response.status);
              return response.json();
            })
            .then((data) => {
              const temp = `parte ${chunkNumber}/${totalChunks} caricata con successo`;
              setStatusUpload(temp);
              setProgressUpload(Number(chunkNumber * chunkProgress));
              chunkNumber++;
              start = end;
              end = start + chunkSize;
              uploadNextChunk();
            })
            .catch((error) => {
               handleError(error)
               setIsLoadingUploadFile(false)
            });
        } else {
          setProgressUpload(100);
          setIsLoadingUploadFile(false)
          setSelectedFile(null);
          setStatusUpload("File caricato con successo");
          setSelectedContenuto(null);
          alertService.success("Contenuto aggiornato con successo", {autoClose: true});
          printAllAree();
        }
      };
  
      uploadNextChunk();
    };

  return {
    handleFileUpload,
    statusUpload,
    progressUpload,
    handleFileChange,
    setSelectedFile,
    selectedFile,
    isLoadingUploadFile
  }
}

export default useFileUpload